/**
 * Shared basemap configuration.
 *
 * We use Esri's "World Dark Gray Base" because it is free, requires no API key,
 * and matches the atlas' dark aesthetic. CartoDB tiles now require an API key
 * and render a watermark when the key is missing.
 */
export const BASEMAP_URL =
  "https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}";

export const BASEMAP_ATTRIBUTION =
  '&copy; <a href="https://www.esri.com/">Esri</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export const BASEMAP_MAX_ZOOM = 16;
